<template>
    <div>
        <Form ref="newFrame" :model="frameTransEntity" :rules="newFrameRules" :label-width="125" inline>
            <FormItem label="协议名称" prop="name">
                <Input v-model="frameTransEntity.name" style="width:200px"/>
            </FormItem>
            <FormItem label="模式类型" prop="modeId">
                <dict-select v-model="frameTransEntity.modeId" namespace="ENUM_CORE-CONTRACT" id="frameTransEntity.TransMode" :exclusion="[]" style="width:200px"/>
            </FormItem>
            <br>
            <FormItem label="转户上游" prop="fromMemberId">
                <payee-select v-model="frameTransEntity.fromMemberId" class="shrug" roleType="LEASEE" ></payee-select>
            </FormItem>
            <FormItem label="转户下游" prop="toMemberId">
                <payee-select v-model="frameTransEntity.toMemberId" class="shrug" roleType="LEASEE" ></payee-select>
            </FormItem>
            <br>
            <FormItem label="标的物小类" prop="targetType">
                <targetTypeCascader v-model="frameTransEntity.targetType" />
            </FormItem>
            <FormItem label="指定框架协议" prop="appointFrameRent">
                <Input v-model="frameTransEntity.appointFrameRent" disabled/>
            </FormItem>
            <Button type="primary" style="margin-left:20px" @click="openModal" :disabled="!frameTransEntity.toMemberId||!frameTransEntity.targetType">选择</Button>
            <br>
            <FormItem label="租金单价" prop="transUnitRental">
                <InputNumber v-model="frameTransEntity.transUnitRental" :min="0" style="width:200px"/>
            </FormItem>
            <FormItem label="服务费单价" prop="transUintService">
                <InputNumber v-model="frameTransEntity.transUintService" :min="0" style="width:200px"/>
            </FormItem>
        </Form>

        <div style="text-align:center;width:700px;margin:30px">
            <Button type="primary" style="margin-left:20px" @click="onSubmit">提交</Button>
            <Button type="warning" style="margin-left:20px" @click="back">返回</Button>
        </div>

        <frameRentModal ref="frameRentModal" :queryParams="{memberId:frameTransEntity.toMemberId,targetType:frameTransEntity.targetType}" @onFinish="selectAgreement"/>
    </div>
</template>

<script>
import dictSelect from '@/components/select/dict-select.vue';
import payeeSelect from '@/components/select/payee-select.vue';
import targetTypeCascader from '@/components/select/targetType-cascader.vue';
import frameRentModal from './frame-rent-modal.vue';
export default {
    components: {
        dictSelect,
        payeeSelect,
        targetTypeCascader,
        frameRentModal
    },
    data(){
        return{
            frameTransEntity : {
                transUnitRental : '',
                transUintService : '',
                appointFrameRent : ''
            },
            newFrameRules : {
                name: [
                    { required: true, message: '请输入协议名称', trigger: 'blur' }
                ],
                modeId: [
                    { required: true, message: '请选择协议模式', trigger: 'blur' }
                ],
                fromMemberId: [
                    { required: true, message: '请选择转户上游', trigger: 'blur' }
                ],
                toMemberId: [
                    { required: true, message: '请选择转户下游', trigger: 'blur' }
                ],
                targetType: [
                    { required: true, message: '请选择标的物小类', trigger: 'blur' }
                ],
                transUnitRental: [
                    { required: true, type: 'number', message: '请输入租金单价', trigger: 'blur' }
                ],
                transUintService: [
                    { required: true, type: 'number', message: '请输入服务费单价', trigger: 'blur' }
                ],
            }
        }
    },
    mounted(){

    },
    methods:{
        async onSubmit(){
            let valid = await this.$refs['newFrame'].validate();
            if(!valid) return;
            let params = {
                url : 'http://CORE-CONTRACT/messageService/billingModelService/addFrameTransEntity',
                body : {
                   frameTransEntity : this.frameTransEntity
                }
            }
            this.invoke(params).then((rs)=>{
                if(rs){
                    this.$Message.info('添加成功!');
                    this.back();
                }
            });
        },
        openModal(){
            this.$refs['frameRentModal'].openModal();
        },
        selectAgreement(val){
            this.frameTransEntity.appointFrameRent = val.id;
        },
        back(){
            this.$emit('on-finish',{});
        }
    }
}
</script>